<template>
    <div class="visible-user-container inner-padding-sm scroll p-l-25 p-r-20 add-pointer" @click="selectUser">
        <div class="pull-left">
            <div class="visible-user-label text-bold">
                <span>{{ first_nm }}</span>
                <span>{{ last_nm}}</span>
                <span v-if="last_nm"> - </span>
                <span>{{ email }}</span>
            </div>
        </div>

    </div>
</template>

<style lang="scss">

    @import '../../sass/_global_variables.scss';

    .visible-user-container > * {
        display: inline-block;
    }

    .visible-user-container > :last-child {
        float: right;
    }

    .visible-user-container:not(:last-child) {
        border-bottom : 1px solid $border-gray;
    }

    .visible-user-container:hover {
        background: #d9e6f7;
    }


    @media (max-width: $break-md) {
        .visible-user-container > * {
            display: block;
        }

        .visible-user-container > :last-child {
            float: left;
            margin-top: 5px;
        }
    }
</style>

<script>
    module.exports = {
        props: {
            user_id: { default: null },
            first_nm: { default: null },
            last_nm: { default: null },
            email: { default: null },
        },

        methods: {
            selectUser: function(event) {
                this.$emit('select', this.user_id, this.first_nm, this.last_nm, this.email);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// visible-user-list-item.vue?29fc9c2e